import {
  ControlDisabledSubtree,
  useBespokeSectionContext,
} from '../../primitives';
import { useLayoutDerived } from '../LayoutDerivedContext';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { DisabledWhenNode } from '../types';
import { RenderNodes } from '../renderNodes';
import { whenClauseSatisfied } from '../whenClause';

export function DisabledWhenBlock({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<DisabledWhenNode>) {
  const { schemaMap } = useBespokeSectionContext();
  const derived = useLayoutDerived();
  const list = Array.isArray(node.whenAll) ? node.whenAll : [];
  const clausesPass =
    list.length === 0 ||
    list.every(w =>
      whenClauseSatisfied(w, answers, repeatBindings, derived, schemaMap)
    );
  const gateDisables = list.length > 0 && !clausesPass;
  return (
    <ControlDisabledSubtree disabled={gateDisables} className={node.className}>
      <div className='space-y-4' style={layoutInlineStyle(node.style)}>
        <RenderNodes
          nodes={node.children}
          answers={answers}
          repeatBindings={repeatBindings}
        />
      </div>
    </ControlDisabledSubtree>
  );
}
